import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const toolsMappingDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.editMapping',
        popover: {
          title: 'Edit Tool Mapping',
          description:
            'Use this option to modify an existing mapping between tools and customers. Ensure that all changes reflect the current tool requirements.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.deleteMapping',
        popover: {
          title: 'Delete Tool Mapping',
          description:
            'This option allows you to remove an existing mapping between tools and customers. Please ensure the mapping is no longer required before deleting, as this action cannot be undone.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.toolsMappingMainTable',
        popover: {
          title: 'Tools Mapping Overview',
          description:
            'This table provides a comprehensive overview of all current tool mappings, allowing you to manage the associations between tools and customers effectively.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.customerToolMappingTable',
        popover: {
          title: 'Customer Tenant Tool Mapping Overview',
          description:
            'This table provides a comprehensive overview of all current customer tenant tool mappings, allowing you to manage the associations between tools and customers effectively.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default toolsMappingDriverObj;
